import React, { useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import EmailLoginForm from "./EmailLoginForm";
import EmailRegisterForm from "./EmailRegisterForm";
import EmailVerificationSentView from "./EmailVerificationSentView";

const IndividualEmailFlow = ({ getDashboardTargetUrl }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { schoolId } = useParams();

  const isLoginMode = location.pathname.startsWith("/login");
  const [verificationData, setVerificationData] = useState(null);

  const handleVerificationSent = (data) => {
    setVerificationData(data);
  };

  const handleUnverified = (email) => {
    setVerificationData({ email, name: "", registerAs: "parent", password: "" });
  };

  const handleBackToForm = () => {
    setVerificationData(null);
  };

  if (verificationData?.email) {
    return (
      <EmailVerificationSentView
        email={verificationData.email}
        name={verificationData.name}
        registerAs={verificationData.registerAs}
        password={verificationData.password}
        schoolId={schoolId}
        onBack={handleBackToForm}
        getDashboardTargetUrl={getDashboardTargetUrl}
      />
    );
  }

  if (isLoginMode) {
    return (
      <EmailLoginForm
        onBack={() => navigate("/login" + (location.search || ""))}
        onSwitchToRegister={() => navigate("/register/email" + (location.search || ""))}
        onUnverified={handleUnverified}
        getDashboardTargetUrl={getDashboardTargetUrl}
      />
    );
  }

  return (
    <EmailRegisterForm
      onBack={() => navigate("/register" + (location.search || ""))}
      onSwitchToLogin={() => navigate("/login/email" + (location.search || ""))}
      onVerificationSent={handleVerificationSent}
    />
  );
};

export default IndividualEmailFlow;
